import React, { useEffect, useState } from 'react';
import {Link, useNavigate} from 'react-router-dom';
import { connect } from 'react-redux';

// reactstrap components
import {
  Button,
  Form,
  Card,
  CardTitle,
  CardHeader,
  CardBody,
  CardFooter,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Col,
  Row,
  Modal,

} from 'reactstrap';

import { registerUser } from '../../actions/registerActions';

import logo from 'assets/img/aotm.png';
import background from 'assets/img/background.jpg'; 
import { set } from 'date-fns';

function RegisterPage({ registerUser, success, error, loading }) {
  
  const [formData, setFormData] = useState({
    email: '',
    password1: '',
    password2: '',
    first_name: '',
    last_name: '',
    telephone: '',
  });

  useEffect(() => {
    document.body.classList.toggle('login-page');
    return function cleanup() {
      document.body.classList.toggle('login-page');
    };
  });

  const handleFieldChange = (e) => {
    const fieldValue = e.target.value;
    const fieldIndex = e.target.id;

    setFormData((prevState) => {
      const prevLoginValues = { ...prevState };
      prevLoginValues[fieldIndex] = fieldValue;
      return prevLoginValues;
    });
  };

  const [modalMini, setModalMini] = useState(false);
  const [modalMiniNew, setModalMiniNew] = useState(false);
  const toggleModalMini = () => {
    setModalMini(!modalMini);
  };
  const toggleNewModal = () => {
    setModalMiniNew(!modalMiniNew);
  };
  // const errorDict = {
  //   'Email already used.': 'Konto na podany adres e-mail już istnieje',
  //   'Passwords don\'t match.': 'Hasła nie są identyczne',
  //   "Passwords don't follow requirements.": "Hasło nie spełnia wymagań"
  // }
  const [frontError, setFrontError] = React.useState(false)
  const [message, setMessage] = React.useState('')

  const handleSubmit = () => {
    // e.preventDefault();
    
   let errorMessage = ""
    setMessage("");
    const telNum  = (' ' + formData.telephone).slice(1)
    const telNum2  = telNum.replaceAll("(","").replaceAll(")","").replaceAll("-","").replaceAll(" ","").replaceAll("+","")
    if(isNaN(telNum2)) {errorMessage= "Wykryto niepoprawne znaki w numerze telefonu. ";}

    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if(!re.test(String(formData.email).toLowerCase())){
      errorMessage= errorMessage + " Niepoprawny adres email"
      }
    console.log(frontError)
    console.log(formData)
    if(errorMessage !==""){ setMessage(errorMessage); toggleNewModal() ;return 0;}
   
    registerUser(formData) ;
    toggleModalMini()
  };
  

  const navigate = useNavigate();
  const goToLogin = () => {
    navigate('/admin/login')
  }


  return (
    <div className='register-page'>
      <Container>
        <Row>
          <Col className="ml-auto mr-auto" md="12">
            <ul className="breadcrumb-links" style={{margin: 0}}>
              <li><a href="/">Strona główna</a></li>
              <li>Rejestracja</li>
            </ul>
          </Col>
        </Row>
      </Container>
      <Container>
        <Row>
          <Col className='ml-auto' lg='6' md='6' sm='6' xs='12'>
            <Card
              className={'register-card-image'}
              style={{ backgroundImage: `url(${background})`}}
            ></Card>
          </Col>
          <Col className='ml-auto mr-auto' lg='4' md='6' sm='6' xs='12'>
            <Form className='form'>
              <Card className='card-register'>
                <CardHeader>
                  <div className={'logo-container'}>
                    <img
                      src={logo}
                      className='login-img img-circle img-no-padding img-responsive'
                      alt='AOTMiT logo'
                    />
                  </div>
                  <CardTitle className='text-center' tag='h3'>
                    Zarejestruj się
                  </CardTitle>
                </CardHeader>
                <CardBody>
                  <InputGroup>
                    <InputGroupAddon addonType='prepend'>
                      <InputGroupText>
                        <i className='nc-icon nc-single-02' />
                      </InputGroupText>
                    </InputGroupAddon>
                    <label htmlFor='first_name' className='sr-only'>imię</label>
                    <Input
                      id={`first_name`}
                      placeholder='imię'
                      type='text'
                      value={formData.first_name}
                      onChange={(e) => handleFieldChange(e)}
                    />
                  </InputGroup>
                  <InputGroup>
                    <InputGroupAddon addonType='prepend'>
                      <InputGroupText>
                        <i className='nc-icon nc-single-02' />
                      </InputGroupText>
                    </InputGroupAddon>
                    <label htmlFor='last_name' className='sr-only'>nazwisko</label>
                    <Input
                      id={`last_name`}
                      placeholder='nazwisko'
                      type='text'
                      value={formData.last_name}
                      onChange={(e) => handleFieldChange(e)}
                    />
                  </InputGroup>
                  <InputGroup>
                    <InputGroupAddon addonType='prepend'>
                      <InputGroupText>
                        <i className='nc-icon nc-mobile' />
                      </InputGroupText>
                    </InputGroupAddon>
                    <label htmlFor='telephone' className='sr-only'>nr telefonu</label>
                    <Input
                      id={`telephone`}
                      placeholder='nr telefonu'
                      type='telephone'
                      value={formData.telephone}
                      onChange={(e) => handleFieldChange(e)}
                    />
                  </InputGroup>
                  <InputGroup>
                    <InputGroupAddon addonType='prepend'>
                      <InputGroupText>
                        <i className='nc-icon nc-email-85' />
                      </InputGroupText>
                    </InputGroupAddon>
                    <label htmlFor='email' className='sr-only'>e-mail</label>
                    <Input
                      id={`email`}
                      placeholder='e-mail'
                      type='email'
                      value={formData.email}
                      onChange={(e) => handleFieldChange(e)}
                      required 
                    />
                  </InputGroup>
                  <InputGroup className='pb-0'>
                    <InputGroupAddon addonType='prepend'>
                      <InputGroupText>
                        <i className='nc-icon nc-key-25' />
                      </InputGroupText>
                    </InputGroupAddon>
                    <label htmlFor='password1' className='sr-only'>hasło</label>
                    <Input
                      id={`password1`}
                      placeholder='Hasło'
                      type='password'
                      // autoComplete='off'
                      value={formData.password1}
                      onChange={(e) => handleFieldChange(e)}
                      required 
                    />
                  </InputGroup>
                  <InputGroup>
                    <InputGroupAddon addonType='prepend'>
                      <InputGroupText>
                        <i className='nc-icon nc-key-25' />
                      </InputGroupText>
                    </InputGroupAddon>
                    <label htmlFor='password2' className='sr-only'>potwierdź hasło</label>
                    <Input
                      id={`password2`}
                      placeholder='Potwierdź hasło'
                      type='password'
                      // autoComplete='off'
                      value={formData.password2}
                      onChange={(e) => handleFieldChange(e)}
                      required 
                    />
                  </InputGroup>
                  <Row className=' mx-2'>
                    <Col  className='p-0'><i>Hasło powinno mieć co najmniej 8 znaków oraz zawierać wielką literę, cyfrę i&nbsp;znak specjalny.</i></Col>  
                  </Row>
                  
                </CardBody>
                <CardFooter>
                  <Button
                    block
                    className='btn-round btn-outline-aotmit mb-3 btn-shadow'
                    color='aotmit'
                    type='button'
    
                    onClick={(e) =>{handleSubmit()}} 
                  >
                    Zarejestruj
                  </Button>
                  <div className='login'>
                    <p>
                      Posiadasz już konto?{' '}
                      <Link
                        to='/auth/login'
                        // onClick={(e) => e.preventDefault()}
                      >
                        Zaloguj się
                      </Link>
                      .
                    </p>
                  </div>
                </CardFooter>
              </Card>
            </Form>
          </Col>
        </Row>
      </Container>
      {/* <Container> */}
      {/* <Row>
          <Col className="ml-auto mr-auto" lg="4" md="6">
            <Form action="" className="form" method="">
              <Card className="card-login">
                <CardHeader >
                  <div className={"logo-container"}>
                    <img
                      src={logo}
                      className="login-img"
                      alt="AOTMiT logo"
                    />
                  </div>

                  <h5 className={"header card-login-title"}>
                    Zaloguj się
                  </h5>
                </CardHeader>
                <CardBody>
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="nc-icon nc-single-02" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input placeholder="First Name..." type="text" />
                  </InputGroup>
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="nc-icon nc-key-25" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="Password"
                      type="password"
                      autoComplete="off"
                    />
                  </InputGroup>
                  <br />

                </CardBody>
                <CardFooter>
                  <Button
                    block
                    className="btn-round mb-3"
                    color="aotmit"
                    href="#pablo"
                    onClick={(e) => e.preventDefault()}
                  >Zaloguj</Button>
                </CardFooter>
              </Card>
            </Form>
          </Col>
        </Row> */}
      {/* </Container> */}
      <div
        className='full-page-background'
        // style={{
        //   backgroundImage: `url(${
        //     require("assets/img/bg/fabio-mangione.jpg").default
        //   })`,
        // }}
      />
      <Modal
        className="modal-sm"
        modalClassName="modal-primary"
        isOpen={modalMini}
        // toggle={toggleModalMini}
      >
        <>{!loading?<><div className="modal-header justify-content-center">
          <div className="modal-profile ml-auto mr-auto">
          {error===null?<i className="nc-icon nc-check-2" />:<i className="nc-icon nc-simple-remove" />}
          </div>
        </div>
        <div className="modal-body">
          <p>{error===null?'Twoje konto zostało pomyślnie utworzone.':error}</p>
        </div>
        <div className="modal-footer">
          {/* <div className="left-side">
            <Button color="link" type="button">
              Back
            </Button>
          </div>
          <div className="divider" />
          <div className="right-side"> */}
            {error===null?
            <Button
              color="link"
              data-dismiss="modal"
              type="button"
              onClick={()=>goToLogin()}
            >
              Przejdź do logowania
            </Button>:<Button
              color="link"
              data-dismiss="modal"
              type="button"
              onClick={()=>{toggleModalMini(); setFrontError(false)}}
            >
              Rozumiem
            </Button>}
          {/* </div> */}
        </div></>:<><div className="modal-header justify-content-center">
          <div className="modal-profile ml-auto mr-auto">
          <i className="fas fa-spinner fa-spin"></i>
          </div>
        </div>
        <div className="modal-body">
          <p>Przetwarzanie...</p>
        </div>
        </>}</>
      </Modal>

      <Modal
       className="modal-sm"
       modalClassName="modal-primary"
       isOpen={modalMiniNew}>
      <>
        <div className="modal-header justify-content-center">
          <div className="modal-profile ml-auto mr-auto">
          <i className="nc-icon nc-simple-remove" /></div></div>
          <div className="modal-body">
          <p>{message}</p>
        </div>
        <div className="modal-footer">
        <Button
              color="link"
              data-dismiss="modal"
              type="button"
              onClick={()=>toggleNewModal()}
            >
              Rozumiem
            </Button>
        </div>
        </>
      </Modal>
      
    </div>
  );
}

const mapStateToProps = (state) => ({
  success: state.registerReducer.success,
  loading: state.registerReducer.loading,
  error: state.registerReducer.error
});

// export default connect(mapStateToProps, { loginUser })(Login)

export default connect(mapStateToProps, { registerUser })(RegisterPage);
